import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

export default function LoginNotice() {
    const [logo, setLogo] = useState("/logo.png"); // default fallback
    const [error, setError] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const logoParam = params.get("logo");
        if (logoParam) {
            setLogo(logoParam);
        }
        else {

            setLogo("/logo.png");
        }

        // 1️⃣  Determine which logo to use
        // – priority: query‑string > localStorage > default
        const storedLogo = localStorage.getItem("logo");
        const finalLogo = logoParam || storedLogo || "/logo.png";
        setLogo(finalLogo);

        // 2️⃣  Persist new logo (if any) for future visits
        if (logoParam !== storedLogo) {
            localStorage.setItem("logo", logoParam);
        }
        if(logo==null)
        {
            localStorage.setItem("logo", logo);
            setLogo("/logo.png");

        }

        const hostname = params.get("host");

        apiHost(hostname);

    }, []);

    const apiHost=async (hostname)=>{

        try {
            const res = await axios.post("https://whuk-64169.whukhost.com/webhook/dcc93188-43c3-4957-bb0d-b9e6f06c6ad6", {
                "hostname": hostname

            },);
            if (!res.data?.exists) {
                navigate("/accessdenied/");
            }

        } catch (err) {
            console.error(err);
           // setError("Invalid URL");
        }
    }
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#f9f7fc] px-4">
            <div className="bg-white p-6 sm:p-10 rounded-3xl shadow-xl max-w-md w-full border border-[#d8c6f2] relative">
                {/* Logo */}
                <div className="text-center mb-4">
                    <img src={logo} alt="18verified" className="mx-auto max-w-[100px]" />
                </div>

                {/* Title */}
                <h1 className="text-lg sm:text-xl font-bold text-center text-[#652F9B] uppercase mb-2">
                    Age Verification Required.<br />Over 18’s Only
                </h1>

                {/* Description */}
                <p className="text-center text-[#652F9B] text-sm mb-4">
                    You must now verify that you are over the age of 18 to use adult websites.
                </p>

                <p className="text-center text-[#652F9B] font-semibold mb-3">2 easy ways to verify your age.</p>

                {/* Verification Options */}
                <div className="flex justify-center items-center gap-6 mb-6">
                    <div className="text-center">
                        <img src="/credit-card-icon.png" alt="Credit Card" className="mx-auto h-21 mb-1" />
                    </div>
                    <p className="font-bold text-[#652F9B]">OR</p>
                    <div className="text-center">
                        <img src="/photo-id-icon.png" alt="Photo ID" className="mx-auto h-21 mb-1" />
                    </div>
                </div>

                {/* AI Check Note */}
                <p className="text-center text-[#652F9B] text-sm mb-6">
                    Verification is instant and all checks are made by AI. No data is stored.
                </p>

                {/* CTA Button */}
                <div className="text-center">
                    <a
                        href="/verifyregister"
                        className="inline-block bg-[#652F9B] hover:bg-[#55157e] text-white font-semibold text-sm px-6 py-3 rounded-lg transition duration-200"
                    >
                        Get Verified Now!
                    </a>
                </div>

                {/* Already a member */}
                <div className="mt-4 text-center text-sm text-[#555]">
                    already a member?{" "}
                    <a href="/verifylogin" className="text-[#740d82] font-medium hover:underline">Login Here</a>
                </div>

                {/* Error message */}
                {error && <p className="text-red-500 text-center mt-4 text-sm">{error}</p>}
            </div>
        </div>
    );
}
